import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { evaluatePublicRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService';
import { transformToLegacyPurchaseMotionsShape } from './transformToLegacyPurchaseMotionsShape';
import { getEarlyRequestResult } from '../utils/earlyRequest';
import { getCurrencyRequestRpc } from 'growth-monetization-service-types';
import { getCurrencyStoreResponse } from '../currency/dataTransformer';
const noAuthChirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
const getLegacyCurrencyPromise = () => {
  return getEarlyRequestResult('currency', () => noAuthChirpClient.call(getCurrencyRequestRpc, {})).then(response => {
    const currencyStoreResponse = getCurrencyStoreResponse(response);
    return currencyStoreResponse;
  });
};
export const getPublicAppLegacyPurchaseMotionsResponse = () => {
  const locations = ['MERCH_CARD', 'CALCULATOR'];
  const countryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const publicPurchaseMotionsPromise = noAuthChirpClient.call(evaluatePublicRpc, {
    request: {
      locations,
      productApiNames: [],
      requestedCountryCode: countryCode || undefined
    }
  }).then(purchaseMotionsResponse => {
    return transformToLegacyPurchaseMotionsShape(locations, purchaseMotionsResponse);
  });
  return Promise.all([getLegacyCurrencyPromise(), publicPurchaseMotionsPromise]).then(([currencyStoreResponse, purchaseMotionsResponse]) => {
    return {
      customerCurrencyCode: currencyStoreResponse.lockedCurrencyCode,
      defaultCurrency: currencyStoreResponse.defaultCurrencyCode,
      locations: purchaseMotionsResponse
    };
  });
};